import React from "react";
import { TipoTag, EstadoPill } from "@/components/marca/Pills";

export function TipoBadge({ tipo, className }) {
  return <TipoTag tipo={tipo} className={className} data-testid={`tipo-badge-${tipo}`} />;
}

export function EstadoBadge({ estado, className, conProblema }) {
  return <EstadoPill estado={estado} conProblema={conProblema} className={className} data-testid={`estado-badge-${estado}`} />;
}
